  <div class=" max-w-2xl mx-auto">

  <!-- Nombre del paciente -->
  <div class="mb-2">
    <h2 class="headline-05 text-[#003746] font-bold my-3">Nombre del paciente</h2>
    <mat-radio-group [(ngModel)]="selectedPatient">
      <div class="flex items-center border border-[#DFF2F5] bg-[#D2E4FF29] rounded-[16px] px-4 py-2" [class.border-2]="isSelected('titular')">
        <div class="flex items-center gap-2">
          <svg width="24" height="24" viewBox="0 0 16 21" fill="#003746" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.7543 12.4992C14.9963 12.4992 16.0032 13.5061 16.0032 14.7481V15.3235C16.0032 16.2178 15.6836 17.0826 15.1021 17.762C13.5327 19.5955 11.1455 20.5004 8.00012 20.5004C4.85426 20.5004 2.46825 19.5952 0.901942 17.7609C0.322181 17.082 0.00366211 16.2185 0.00366211 15.3258V14.7481C0.00366211 13.5061 1.01052 12.4992 2.25254 12.4992H13.7543ZM13.7543 13.9992H2.25254C1.83895 13.9992 1.50366 14.3345 1.50366 14.7481V15.3258C1.50366 15.8614 1.69477 16.3795 2.04263 16.7869C3.29594 18.2546 5.26182 19.0004 8.00012 19.0004C10.7384 19.0004 12.706 18.2545 13.9625 16.7866C14.3114 16.379 14.5032 15.8601 14.5032 15.3235V14.7481C14.5032 14.3345 14.1679 13.9992 13.7543 13.9992ZM8.00012 0.503906C10.7615 0.503906 13.0001 2.74248 13.0001 5.50391C13.0001 8.26533 10.7615 10.5039 8.00012 10.5039C5.2387 10.5039 3.00012 8.26533 3.00012 5.50391C3.00012 2.74248 5.2387 0.503906 8.00012 0.503906ZM8.00012 2.00391C6.06712 2.00391 4.50012 3.57091 4.50012 5.50391C4.50012 7.4369 6.06712 9.00391 8.00012 9.00391C9.93312 9.00391 11.5001 7.4369 11.5001 5.50391C11.5001 3.57091 9.93312 2.00391 8.00012 2.00391Z"/>
            </svg>
          <div>
            <p class="font-semibold">{{ nameOwner }}</p>
            <p class="paragraph-small text-[#97795B]">Titular</p>
          </div>
        </div>
        <mat-radio-button class="ml-auto" value="titular"></mat-radio-button>
      </div>
    </mat-radio-group>
  </div>

  <!-- DEPENDIENTES OCULTOS TEMPORALMENTE
  <div class="mb-4">
    <h2 class="headline-05 text-[#003746] font-bold my-3">Dependientes</h2>
    <mat-radio-group [(ngModel)]="selectedPatient" class="space-y-2 block">
      <div *ngFor="let dep of dependent" class="flex items-center border border-[#DFF2F5] bg-[#D2E4FF29] rounded-[16px] px-4 py-2" [class.border-2]="isSelected(dep.name)">
        <div class="flex items-center gap-2">
          <svg width="24" height="24" viewBox="0 0 16 21" fill="#003746" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.7543 12.4992C14.9963 12.4992 16.0032 13.5061 16.0032 14.7481V15.3235C16.0032 16.2178 15.6836 17.0826 15.1021 17.762C13.5327 19.5955 11.1455 20.5004 8.00012 20.5004C4.85426 20.5004 2.46825 19.5952 0.901942 17.7609C0.322181 17.082 0.00366211 16.2185 0.00366211 15.3258V14.7481C0.00366211 13.5061 1.01052 12.4992 2.25254 12.4992H13.7543ZM13.7543 13.9992H2.25254C1.83895 13.9992 1.50366 14.3345 1.50366 14.7481V15.3258C1.50366 15.8614 1.69477 16.3795 2.04263 16.7869C3.29594 18.2546 5.26182 19.0004 8.00012 19.0004C10.7384 19.0004 12.706 18.2545 13.9625 16.7866C14.3114 16.379 14.5032 15.8601 14.5032 15.3235V14.7481C14.5032 14.3345 14.1679 13.9992 13.7543 13.9992ZM8.00012 0.503906C10.7615 0.503906 13.0001 2.74248 13.0001 5.50391C13.0001 8.26533 10.7615 10.5039 8.00012 10.5039C5.2387 10.5039 3.00012 8.26533 3.00012 5.50391C3.00012 2.74248 5.2387 0.503906 8.00012 0.503906ZM8.00012 2.00391C6.06712 2.00391 4.50012 3.57091 4.50012 5.50391C4.50012 7.4369 6.06712 9.00391 8.00012 9.00391C9.93312 9.00391 11.5001 7.4369 11.5001 5.50391C11.5001 3.57091 9.93312 2.00391 8.00012 2.00391Z"/>
            </svg>
          <div>
            <p class="font-semibold">{{ dep.name }}</p>
            <p class="paragraph-small text-[#97795B]">{{ dep.catalog.description }}</p>
          </div>
        </div>
        <mat-radio-button class="ml-auto" [value]="dep.name"></mat-radio-button>
      </div>
    </mat-radio-group>
    <div 
      class="w-full mt-3 border border-[#0E365A] text-[#0E365A] rounded-[16px] cursor-pointer py-3 px-4 flex items-center justify-between hover:bg-gray-50"
      (click)="addNewDependent()">
      <span>Agregar nuevo dependiente</span>
      <mat-icon>add</mat-icon>
    </div>
  </div>
  FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->


  <!-- Botón solicitar -->
  <button 
    class="bg-[#052631] text-white w-full py-3 rounded-full" 
    (click)="requestReference()">
    Solicitar
  </button>
</div>
